import { useIntl } from 'react-intl'
import type { FareClassWithReward } from 'constants/flight'
import { getCharterFareClassDisplayLabel } from 'hooks/Flights/useCharterFlightLabels'
import OfferFilterDropdownBox from '../OfferFilterDropdownBox'
import LineSeatIcon from 'LuxKit/Icons/line/LineSeatIcon'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOpenCharterFareClassModal from 'hooks/OfferPage/useOpenCharterFareClassModal'

interface Props {
  offer?: App.Offer
  fareClass: FareClassWithReward
  className?: string
  checkInDate?: string
  checkOutDate?: string
  occupancies: Array<App.Occupants>
  airport?: App.Airport
}

function CharterFlightFareClassSelect({ offer, fareClass, className, checkInDate, checkOutDate, occupancies, airport }: Props) {
  const intl = useIntl()
  const { canOpen, open, hasExplicitFareClass } = useOpenCharterFareClassModal({
    offer,
    fareClass,
    checkInDate,
    checkOutDate,
    occupancies,
    feederOriginAirportCode: airport?.code,
  })

  if (!canOpen) {
    return null
  }

  const value = !hasExplicitFareClass
    ? undefined
    : <b>{getCharterFareClassDisplayLabel(intl, fareClass)}</b>

  return (
    <OfferFilterDropdownBox
      className={className}
      data-testid="fare-class-select"
      onClick={() => open()}
      icon={<LineSeatIcon />}
      label={intl.formatMessage({
        id: 'qziWiR2Ojnm1pUMoGMst',
        defaultMessage: 'Class',
        description: 'Label for charter flight fare class selector in the flights flow',
      })}
      value={value}
      placeholder={intl.formatMessage({
        id: 'Y7XGF9bZxNQEK89br8_j',
        defaultMessage: 'Select cabin',
        description: 'Placeholder text for cabin class filter chip when no fare class is selected',
      })}
    />
  )
}

type MappedProps = Pick<Props, 'offer' | 'fareClass' | 'checkInDate' | 'checkOutDate' | 'occupancies' | 'airport'>

export default withOfferPageState((state): MappedProps => ({
  offer: state.offer,
  fareClass: state.fareClass,
  checkInDate: state.checkInDate,
  checkOutDate: state.checkOutDate,
  occupancies: state.rooms,
  airport: state.airport,
}), CharterFlightFareClassSelect)
